import Vue from 'vue'
import Vuex from 'vuex'

import { Util } from "./util";

Vue.use(Vuex)

export const storeMutations = {
    changeLocation: "changeLocation"
}

const store = new Vuex.Store({
    state: {
        /** Listado de beneficios cargados en cliente (se trajeron del server) */
        beneficios: null,
        categoria: null,
        categorias: null,
        location: null,
        subcategoria: null,
    },
    mutations: {
        agregarBeneficio(state, beneficio) {
            state.beneficios.push(beneficio);
        },
        beneficioUpdate(state, {beneficioId, data}){
            const beneficio = state.beneficios.find((b) => b.id == beneficioId);

            if(beneficio){
                if(data.suscripto !== undefined){
                    Vue.set(beneficio, 'suscripto', data.suscripto);
                }
            }
        },
        cambiarCategoria(state, nueva) {
            state.categoria = nueva;
        },
        [storeMutations.changeLocation](state, newLocation) {
            state.location = newLocation;
        },
        cambiarSubcategoria(state, nueva) {
            state.subcategoria = nueva;
        },
        cargarBeneficios(state, lista) {
            state.beneficios = lista;
        },
        cargarCategorias(state, lista) {
            state.categorias = lista;
        },
        eliminarBeneficio(state, beneficio) {
            Util.eliminarElemento(state.beneficios, beneficio);
        },
        limpiarBeneficios(state) {
            state.beneficios = [];
        },
        limpiarSubcategoria(state) {
            state.subcategoria = null;
        }
    }
})

export default store